export const InterviewPropertySelectList = [
  { label: 'Language', value: 'language' },
  { label: 'Qualified', value: 'qualified' },
  { label: 'Total score', value: 'total_score' },
];

export enum EInterviewProperty {
  Language = 'language',
  Qualified = 'qualified',
  TotalScore = 'total_score',
}
